module.exports = __webpack_public_path__ + "img/offers6.5799c6b2.webp";